import {Context} from '@acng/frontend-relativity';

/**
 * @type {Local<Gallery>}
 */
export const ctxGallery = Context();
